<template>
  <div>
    <Func4RedeCredenciada v-show="!showPrint && !showRedeVazia" />
    <Func4Print v-if="showPrint && printType === 'list'" />
    <Func4PrintPrestador v-if="showPrint && printType !== 'list'" />
    <RedeVazia v-if="showRedeVazia" />
  </div>
</template>

<script>

import Func4RedeCredenciada from '@/views/4/RedeCredenciada'
import Func4Print from '@/views/4/print/Print'
import { mapActions, mapState } from 'vuex'
import Func4PrintPrestador from '@/views/4/print/PrintPrestador'
import RedeVazia from '@/views/4/RedeVazia'

export default {
  name: 'Func4',
  components: { RedeVazia, Func4PrintPrestador, Func4Print, Func4RedeCredenciada },
  computed: {
    ...mapState('RedeCredenciada', ['printType', 'showPrint', 'showRedeVazia']),
    ...mapState('SetupApp', ['embedJson', 'frameId'])
  },
  methods: {
    ...mapActions('SetupApp', ['setKeepHeightUpdated']),
    ...mapActions(
      'RedeCredenciada', [
        'setDensidade',
        'setApenasGuiaImpresso',
        'setPermiteGeolocalizacao',
        'setSolicitaGeolocalizacaoNoCarregamento',
        'setGeolocalizacao',
        'setFiltroPlanos'
      ])
  },
  mounted () {
    this.setKeepHeightUpdated(false)

    let densidade = 0

    if (this.embedJson) {
      if (this.embedJson.painelDensidade) {
        densidade = this.embedJson.painelDensidade
      }
      // Geolocation
      if (this.embedJson.lat && this.embedJson.lng) {
        this.setGeolocalizacao(
          {
            lat: parseFloat(this.embedJson.lat),
            lng: parseFloat(this.embedJson.lng)
          }
        )
      } else if (this.embedJson.permiteGeolocalizacao) {
        const payload = {
          origin: 'omnichannel',
          client: this.frameId,
          type: 'command',
          command: 'PERMISSION_GEOLOCATION',
          data: {},
          timestamp: Date.now()
        }
        window.parent.postMessage(payload, '*')
      }
    }

    this.setDensidade(densidade)
    this.setPermiteGeolocalizacao(!!(this.embedJson.permiteGeolocalizacao))
    this.setApenasGuiaImpresso(!!(this.embedJson.apenasGuiaImpresso))
    this.setSolicitaGeolocalizacaoNoCarregamento(!!(this.embedJson.solicitaGeolocalizacaoNoCarregamento))
    const bodyClass = `densidade-${densidade}`
    document.body.classList.add(bodyClass)
  },
  created () {
    if (this.embedJson.planos) {
      this.setFiltroPlanos(this.embedJson.planos)
    }
  }
}
</script>
